<template>
  <div id="app">
    <Header
      v-show="!$route.meta.hideHeader"
      @toBeCached="addComponentToCache"
      @toBeNotCached="removeComponentToCache"
    />
    <router-view v-slot="{ Component }">
      <keep-alive :include="componentsToCache">
        <component
          :is="Component"
          :key="$route.path"
          @toBeCached="addComponentToCache"
          @toBeNotCached="removeComponentToCache"
        />
      </keep-alive>
    </router-view>
    <Footer v-show="!$route.meta.hideFooter" />
  </div>
</template>


<script>
import Footer from "../src/components/Footer";
import Header from "../src/components/Header";

export default {
  name: "app",
  components: {
    Footer,
    Header,
  },
  data() {
    return {
      componentsToCache: [
        "Documentation", //cached in any events
        "Collection",
        "Tutorials",
        "GoodPractices",
        "SearchPage", //to be refreshed when user changed
        "MyActivities", //to be refreshed when user changed and when Menu4T.vue->Create.vue, ActivityEdit asks it
        "MySequences", //to be refreshed when user changed and when create.vue, SequenceEdit
        "AdminActivities", //to be refreshed when user changed when create.vue, ActivityEdit
        "AdminSequences", //to be refreshed when user changed when create.vue, SequenceEdit,
      ],
    };
  },
  watch: {
    currentUser: function () {
      console.log("App user changed");
      this.componentsToCache = ["Documentation"];
    },
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title || "Eleda";
      },
    },
  },

  mounted() {},
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },

  methods: {
    addComponentToCache(componentName) {
      console.log("App addComponentToCache", componentName);
      if (!this.componentsToCache.includes(componentName))
        this.componentsToCache.push(componentName);
    },
    removeComponentToCache(componentName) {
      console.log("App removeComponentToCache", componentName);
      const index = this.componentsToCache.indexOf(componentName);
      if (index > -1) {
        this.componentsToCache.splice(index, 1);
      }
    },
  },
};
</script>

<style>
</style>